import React, { useEffect, useState, useMemo } from "react";
import { useParams } from "react-router-dom";

import {
  Box,
  Container,
  Typography,
  Paper,
  Stack,
  Button,
  Divider,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import FullscreenHero from "../components/hero/hero";
import ApplicationForm from "../components/form/form";

import { fetchPreview } from "../controllers/job-controllers";
import { createContext } from "react";

import JobBenefits from "../components/job-details/job-benefits";

import Informations from "../components/informations/informations";
import AboutCompany from "../components/about-company/about-company";
import Benefits from "../components/benefits/benefits";
import Skills from "../components/skills/skills";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import JobPage from "../sections/JobPage";

export const PageContext = createContext({});

export const PageConsumer = PageContext.Consumer;

export default function PreviewPage({ company }) {
  const params = useParams();
  const previewId = params.id;
  const [jobData, setJobData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchPreview(previewId).then((res) => {
      if (res?.error) {
        if (res?.error == "not_found") {
          navigate("/404", { replace: true });
        }
      } else {
        setJobData(res);
      }
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>
          {company?.name ? `Preview | ${company?.name}` : "Preview"}
        </title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <JobPage hideApply={true} jobData={jobData} company={company} />
    </>
  );
}
